import styled from 'styled-components';

const NoData = styled.div`
  width:100%;
  display: flex;
  border-radius:6px;
  background: #FEFEFE99;
  padding: 48px 16px;
  flex-wrap:wrap;
  .image{
    width:100%;
    display:flex;
    justify-content:center;
  }
  .no-data{
    font-family: Lato;
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0%;
    width:100%;
    display:flex;
    justify-content:center;
    margin: 20px 0;
  }
  .subtext{
    font-family: Lato;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: center;
    display:flex;
    width:100%;
    justify-content:center;
  }
  .button{
    display:flex;
    justify-content:center;
    width:100%;
    margin-top:28px;
  }

`;

const Heading = styled.div`
width:100%;
display:flex;
font-family: Lato;
font-weight: 700;
font-size: 18px;
line-height: 24px;
letter-spacing: 0%;
color: #184A61;
align-items:center;
margin-bottom:20px;
>span{
  font-family: Lato;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #989898;
  margin-left:12px;
  align-items:center;
}
`;

const WrapCard = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;

  .user-card {
    width: 402px;
    min-height: 362px;
    background: #FEFEFE99;

    display: flex;
    flex-direction: column; /* IMPORTANT */
  }
`;


const ManagerCard = styled.div`
width:100%;
display:flex;
flex-wrap:wrap;
border-radius:6px;
padding: 16px 0 12px 0;
.heading{
  width: 100%;
  padding: 0 16px 20px 24px;
  border-bottom:1px solid #EFEFEF;
  display:flex;
  .image{
    width: 60px;
    height:60px;
    border-radius:50%;
    >img{
      width: 60px;
      height:60px;
    }
  }
  .title{
    font-family: Lato;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0%;
    color: #184A61;
    display:flex;
    align-items:center;
    margin-left:12px;
  }
  .menu{
    display:flex;
    margin: auto 0 auto auto;
  }
} 
.wrap-user{
  display:flex;
  flex-wrap:wrap;
  gap: 20px;
  margin-top:20px;
  padding: 0px 16px;
  width:100%;
  height:auto;
}
.button-wrap{
  width:100%;
  display:flex;
  justify-content:center;
  height: 48px;
  margin: auto;
}
`;

const Card = styled.div`
 width:100%;
 display:flex;
 padding:8px;
 background: #F8F8F8;
 border-radius:6px;
 height: 64px;
 .image{
  width:48px;
  height:48px;
  border-radius:50%;
  >img{
    width:48px;
    height:48px;
    border-radius:50%;
  }
 }
 .wrap{
  width:calc(100%- 48px);
  padding-left:12px;
  display:flex;
  flex-wrap:wrap;
  gap:8px;
  .name{
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: #184A61;
    width:100%; 
    justify-content: flex-start;
    display: flex;
  }
  .location{
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    color: #989898;
    width:100%;
    justify-content: flex-start;
    display: flex;
  }
 }
`;

const AddUserCard = styled.div`
width:100%;
display:flex;
.image{
  width:48px;
  height:48px;
  display:flex;
  >img{
    width:48px;
    height:48px;
    border-radius:50%;
  }
}
.name{
  font-family: Lato;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;
  color: #184A61;
  margin: auto auto auto 12px;
}
.checkbox{
  display:flex;
  margin: auto 0 auto auto;
}
`;

export { NoData, Heading, WrapCard, ManagerCard, Card, AddUserCard };